import { Routes } from '@angular/router';
import { AUTH_ROUTES } from './auth/auth.routes';
import { authRequiredChildGuard, authRequiredMatchGuard } from './auth/auth.guards';
import { APP_ROUTE_PATHS, LEGACY_ROUTE_PREFIXES } from './core/routing/app-route-paths';
import { MONITORING_ROUTES } from './monitoring/monitoring.routes';
import { AccessShellComponent } from './shell/access-shell.component';
import { AppShellComponent } from './shell/app-shell.component';
import { NotFoundPageComponent } from './shell/not-found-page.component';
import { SHUTTLE_ROUTES } from './shuttle/shuttle.routes';
import { INSTRUCTIONS_ROUTES } from './instructions/instructions.routes';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: APP_ROUTE_PATHS.signIn
  },
  {
    path: LEGACY_ROUTE_PREFIXES.access,
    children: [
      {
        path: APP_ROUTE_PATHS.signIn,
        pathMatch: 'full',
        redirectTo: `/${APP_ROUTE_PATHS.signIn}`
      },
      {
        path: APP_ROUTE_PATHS.notFound,
        pathMatch: 'full',
        redirectTo: `/${APP_ROUTE_PATHS.notFound}`
      }
    ]
  },
  {
    path: LEGACY_ROUTE_PREFIXES.app,
    children: [
      {
        path: APP_ROUTE_PATHS.operator,
        pathMatch: 'full',
        redirectTo: `/${APP_ROUTE_PATHS.operator}`
      },
      {
        path: APP_ROUTE_PATHS.shuttle,
        pathMatch: 'full',
        redirectTo: `/${APP_ROUTE_PATHS.shuttle}`
      }
    ]
  },
  {
    path: '',
    component: AccessShellComponent,
    children: [
      ...AUTH_ROUTES,
      {
        path: APP_ROUTE_PATHS.notFound,
        component: NotFoundPageComponent
      }
    ]
  },
  {
    path: '',
    component: AppShellComponent,
    canMatch: [authRequiredMatchGuard],
    canActivateChild: [authRequiredChildGuard],
    children: [
      ...MONITORING_ROUTES,
      ...SHUTTLE_ROUTES,
      ...INSTRUCTIONS_ROUTES
    ]
  },
  {
    path: '**',
    redirectTo: `/${APP_ROUTE_PATHS.notFound}`
  }
];
